import { FC } from 'react';
import { AllieBackButtonProps } from './BackButton.types';
import { StyledBackButton } from './BackButton.styles';

export const AllieBackButton: FC<AllieBackButtonProps> = ({
  icon,
  ...rest
}: AllieBackButtonProps) => <StyledBackButton icon={icon ?? undefined} text={''} {...rest} />;
